/********

Varmista että tämä koodi on semanttisesti yhtenäinen TravellerApp.vue:n skriptiosion kanssa.

*********/

import Vue from 'vue'
import './pollyfills'
import VueRouterPrefetch from 'vue-router-prefetch'
import VeeValidate from 'vee-validate'
import TravellerNotify from '@/plugins/TravellerNotify.js'
import TravellerPrivileges from '@/plugins/TravellerPrivileges.js'
import TravellerDataFields from '@/plugins/TravellerDataFields.js'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

import App from './App.vue'
import store from './store'
import router from './router'

// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'
import initProgress from './progressbar'

// library imports
//import sidebarLinks from './sidebarLinks'

import './registerServiceWorker'

Vue.config.productionTip = false

// Bootstrap-asetukset
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

import i18n from './i18n'

import utils from '@/plugins/TravellerUtils.js'
import axios from 'axios'
/* Asetetaan Traveller Axiokselle funktio, joka tarkistaa ennen jokaista
pyyntöä että käyttäjällä on vielä kelvollinen authToken */
const travellerAxios = axios.create()
travellerAxios.interceptors.request.use(function (config) {
  store.commit('refreshAuthToken')
  if (utils.authTokenValid(store.state.auth.tokenObject)) {
    if (config.headers != null) {
      config.headers.AUTH_TOKEN = store.state.auth.tokenObject
    } else {
      config.headers = { AUTH_TOKEN: store.state.auth.tokenObject }
    }
  } else {
    store.commit('setLoginModalVisible')
  }
  return config
})
// response interceptor
travellerAxios.interceptors.response.use(function (response) {
  //console.log(response.headers);
  if (response.headers.auth_token !== undefined) {
    //debugger;
    var data = { authToken: response.headers.auth_token }
    store.commit('storeLoginData', data)
    //console.log('uusi token tallennettu' + data);
  }
  return response
})

Vue.prototype.$traveller_http = travellerAxios

const vtravellerAxios = axios.create()
vtravellerAxios.interceptors.request.use(async function (config) {
  store.commit('refreshVTravellerToken')
  if (!utils.authTokenValid(store.state.auth.vtravellerToken)) {
    //console.log('request token');
    // Parameterize vtraveller username and password.
    let vtUser = null
    let vtPass = null
    if (store.state.system.parameters) {
      vtUser = store.state.system.parameters.vtraveller_username
      vtPass = store.state.system.parameters.vtraveller_password
    }
    if (!vtUser || !vtPass) {
      //console.log('Need to get vTraveller login credentials first');
      await travellerAxios
        .get('/traveller/restui/system/getSystemParameters')
        .then(function (response) {
          if (response.status == 200) {
            vtUser = response.data.vtraveller_username
            vtPass = response.data.vtraveller_password
            store.commit('setSystemParams', response.data)
            //console.log('Got vTraveller login credentials: '+ vtUser +': '+ vtPass);
          }
        })
    }
    await axios
      .post('/vtraveller/auth/login', { username: vtUser, pass: vtPass })
      .then(function (response) {
        if (response.data.authToken !== undefined) {
          //console.log('received token, add to store and sessionstorage');
          var data = { vtravellerToken: response.data.authToken }
          store.commit('storeVTravellerToken', data)
        }
      })
      .catch(() => {})
  }
  //console.log('add token to headers');
  if (config.headers != null) {
    config.headers.Authorization = store.state.auth.vtravellerToken
  } else {
    config.headers = { Authorization: store.state.auth.vtravellerToken }
  }
  //console.log('interceptor done');
  return config
})

vtravellerAxios.interceptors.response.use(function (response) {
  if (response.headers.authorization !== undefined) {
    console.log(
      'received token in response headers, add to store and sessionstorage'
    )
    var data = { vtravellerToken: response.headers.authorization }
    store.commit('storeVTravellerToken', data)
  }
  return response
})

Vue.prototype.$vtraveller_http = vtravellerAxios

// plugin setup
Vue.use(VueRouterPrefetch)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(TravellerNotify)
Vue.use(TravellerPrivileges)
Vue.use(TravellerDataFields)
Vue.use(SideBar, { sidebarLinks: [] })
Vue.use(VeeValidate, { fieldsBagName: 'veeFields' })
locale.use(lang)

// bootstrapin tyylitykset sekä niiden ylikirjoitukset
import './styles.scss'

store.commit('reloadLoginData')

initProgress(router)

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
  //beforeCreate() { store.commit('reloadLoginData'); },
}).$mount('#app')
